import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-45",
  "use": "icon-sheet_icon-45-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-45\"><g transform=\"translate(-85 -146)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\"88.75\" y=\"148.75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M97 154l-2.626 5h5.196L97 164\" /><rect x=\"92.75\" y=\"147.75\" width=\"8.5\" height=\"3.5\" rx=\"1.75\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol